import { Grid } from '@mui/material'
import { debounce } from 'lodash'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { TextFieldLabel } from 'src/components/UI'
import { WorkOrdersContext } from '../../../../../context'
import { workOdersTypes } from '../../../../../context/types'


const Notes = () => {
  const { state: { item }, dispatch: dispatchContext } = useContext(WorkOrdersContext)
  const [newItem, setNewItem] = useState(item)

  const changeItemValue = useCallback(
    (newValue, attr) => {
      dispatchContext({ type: 'SET_ITEM_VALUE', payload: { attr: attr, value: newValue } })
      dispatchContext({ type: workOdersTypes.SET_EDIT_ITEM_VALUE, payload: { attr: attr, value: newValue } })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onItemValueChanged = useMemo(
    () => debounce(changeItemValue, 300),
    [changeItemValue]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setNewItem(item)
  }, [item])

  return (
    <Grid container spacing={2}>
      <Grid item xs={6} marginBottom={2}>
        <TextFieldLabel
          isTextArea
          label='BossCat Notes for Technician:'
          placeholder='**Notes FOR Field Technician**'
          value={newItem.punchlistTechNote || ''}
          size="small"
          onChange={(e) => {
            setNewItem({ ...newItem, punchlistTechNote: e.target.value })
            onItemValueChanged(e.target.value, "punchlistTechNote");
          }}
          multiline
          rows={2}
          labelVariant='h6'
        // disabled={vendorIsPaid}
        />
      </Grid>
      <Grid item xs={6}>
        <TextFieldLabel
          isTextArea
          label='Field Tech Notes:'
          placeholder='**Notes FROM Field Technician**'
          value={newItem.fieldNote || ''}
          size="small"
          onChange={(e) => {
            setNewItem({ ...newItem, fieldNote: e.target.value })
            onItemValueChanged(e.target.value, "fieldNote");
          }}
          multiline
          rows={2}
          labelVariant='h6'
        // disabled={vendorIsPaid}
        />
      </Grid>
    </Grid>
  )
}
export default Notes